import { render, staticRenderFns } from "./SeizureLandInventoriesList.vue?vue&type=template&id=27b07274"
import script from "./SeizureLandInventoriesList.vue?vue&type=script&lang=js"
export * from "./SeizureLandInventoriesList.vue?vue&type=script&lang=js"
import style0 from "./SeizureLandInventoriesList.vue?vue&type=style&index=0&id=27b07274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports